import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { PublicLinkAchFormStore } from '../stores';

/** The public app's achFormStore, typed as the public link store (the page needs setRequest). */
export const usePublicLinkAchFormStore = () =>
  useContext<{
    achFormStore: PublicLinkAchFormStore;
  }>(StoreContext);
